module.exports = __webpack_public_path__ + "img/banner.b1e9c013.jpg";